<template>
	<div class="p-col-12 p-grid">

		<div v-if="!commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeRealTimeImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
		</div>

		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p>For the Agent</p>
			<p class="login-subtitle">Real-time updates on transfer market activity</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Imagine being an agent in the competitive world of football transfers. You need to be on top of your game to secure the best deals for your clients. That's where TiroLibre comes in.</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Our transfer platform delivers real-time updates on transfer market activity, ensuring you never miss a beat. With our extensive network of European clubs, we provide daily recommendations on potential suitors for your clients, keeping you ahead of the competition. </p>
			<p v-if="!commonService.isMobile()" class="login-text">Stay ahead of the game with TiroLibre.</p>
			<p v-if="commonService.isMobile()" class="login-text">To thrive as an agent in football transfers requires being constantly aware of what's happening around you – that's where TiroLibre comes into play.</p>
			<p v-if="commonService.isMobile()" class="login-text">Our transfer platform keeps track of all current events related to this field with real-time updates, making sure nothing escapes your attention. Additionally, we offer daily tips from our extensive network of European clubs about potential partners for your customers – ensuring that you always have an edge over competitors.</p>
			<div v-if="!commonService.isMobile()" :class="isSmallScreen()? 'p-col-5 button-box' : 'p-lg-3 button-box'" style="padding: 0px">
				<Button label="Become an associate" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
		<div v-if="commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeRealTimeImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-8 button-box-mobile" style="margin-top: -30px; margin-bottom: 30px">
				<Button label="Become an associate" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>

</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
		isSmallScreen() {
			return screen.width <= 1600 ? true : false;
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -10px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -0px;
		font-size: x-large;
		font-weight: bold;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>